import React, { useState, useEffect, useRef } from 'react';
import { Form, Drawer, Space, Button, notification } from 'antd';

import SPDynamicFormRender from 'components/base/SPDynamicFormRender';

import { useServicePolicyTemplate } from 'hooks/product-price/service-policy-template';

import { JSONS } from 'jsons';
import emiter, {_EVENTS} from "../../../../events";


interface IComponentProps {
  enums?: any;
  closedHook?: () => void
}
const SPDrawer: React.FC<IComponentProps> = (props) => {
  // 组件所需枚举值
  const { enums, closedHook } = props
  // load后的数据值，用来为非表单类组件使用，如状态显示
  const dataRef = useRef({});
  // form引用
  const [mainForm] = Form.useForm();
  // Drawer打开状态
  const [open, setOpen] = useState(false);
  // 是否为只读态，查看场景
  const [disabled, setDisabled] = useState(false);
  // Drawer的操作栏
  const [actionBar, setActionBar] = useState(<></>);
  // 根据只读态，编辑态，标题有所不同。如编辑订单，查看订单等
  const [title, setTitle] = useState('');

  // todo:hard code,rebuild to consts
  const drawerWidth = '85%';

  const drawerView = JSONS.productPrice.servicePolicyTemplate.drawerView;


  const { getInitData, getSubmitData, drawerSubmit } = useServicePolicyTemplate();

  const onOpen = (data: any = {}) => {
    const drawerInfo = data.drawerInfo;
    dataRef.current = data;
    mainForm.resetFields();
    // 没有rule_code时是新建，无需setFieldsValue
    data.rule_code && mainForm.setFieldsValue(getInitData(data))
    setOpen(true);
    setDisabled(drawerInfo.disabled);
    setActionBar(drawerInfo.disabled ? <ViewBar/> : <ActionBar/>);
    setTitle(drawerInfo.title);
  };

  const onClose = () => {
    dataRef.current = {};
    mainForm.resetFields();
    setOpen(false);
    setDisabled(false);
    setActionBar(ActionBar);
    setTitle('');
    closedHook?.()
  };

  const ActionBar = () => {
    return (
        <Space>
          <Button onClick={onClose}>关闭</Button>
          <Button type="primary" onClick={onFinish}>
            保存
          </Button>
        </Space>
    );
  };

  const ViewBar = () => {
    return (
        <Space>
          <Button onClick={onClose}>关闭</Button>
        </Space>
    );
  };

  const onFinish = () => {
    mainForm.validateFields().then(async (fieldsValue: any) => {
      const values = mainForm.getFieldsValue();
      await drawerSubmit(getSubmitData(values, enums), dataRef.current)
      onClose()
    }).catch((errorInfo) => {
      // TODO 硬编码临时处理
      const errMsgMap: any = {
        name: '【模板名称】未填写完成',
        // policy_limit: '【预定限制】未填写完成',
        mile_limit: '【里程限制】未填写完成',
        pre_pickup: '【提前取车】未填写完成',
        delay_pickup: '【延迟取车】未填写完成',
        pre_return: '【提前还车】未填写完成',
        renewal: '【续租】未填写完成',
        delay_return: '【延迟还车】未填写完成',
        pickup_material: '【取车材料】未填写完成',
        city_traffic_limit: '【城市限行规则】未填写完成',
        drive_area_limit: '【用车区域限制】未填写完成',
        oil_electric_fee: '【油费/电费】未填写完成',
        goods_loss: '【随车物品损失】未填写完成',
        illegal_deposit: '【违章处理】未填写完成',
        road_assist: '【道路救援】未填写完成',
        // home_pickup_fee: '【临时上门取车费】未填写完成',
        force_return_fee: '【强制收车费】未填写完成',
        etc_fee: '【ETC费用】未填写完成',
        clean_fee: '【清洁费】未填写完成',
        invoice_desc: '【发表说明】未填写完成',
      }
      let errMsg = ''

      for (const key in errMsgMap) {
        // 注意：不能直接取第一个。
        // 原因：里程限制 和 用车区域限制 组件有联动关系，新增展现的表单项，再次触发校验时，错误会push到数组的最后
        if (errorInfo.errorFields.find((item: any) => item.name[0].startsWith(key))) {
          errMsg = errMsgMap[key]
          break
        }
      }

      notification.error({
        message: '',
        description: errMsg || '有信息未填写完成'
      })
    });
  }

  useEffect(() => {
    emiter.on(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.VIEW, onOpen);
    emiter.on(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.ADD, onOpen);
    emiter.on(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.EDIT, onOpen);
    return () => {
      emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.VIEW)
      emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.ADD)
      emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.EDIT)
    }
  }, []);

  return (
      <>
        <Drawer
            title={title}
            width={drawerWidth}
            onClose={onClose}
            open={open}
            destroyOnClose
            extra={ actionBar }
        >
          <Form form={mainForm} labelCol={{ span: 4 }} disabled={disabled}>
            <SPDynamicFormRender data={drawerView} enums={enums} />
          </Form>
        </Drawer>
      </>
  );
}

export default SPDrawer;



